import React, { useState, useEffect, useRef } from "react";
import { useAuth } from "../context/AuthContext";
import { ConfirmationModal } from "../Modal/MainModal";
import { useNavigate } from "react-router-dom";
import { handlePrintToPDF } from "../utils/prints";

const JoiningReportForm = ({ eid, data }) => {
  const printRef = useRef();
  const { user, logout, checkAuthStatus } = useAuth();
  const [formData, setFormData] = useState({
    // Employee filled section
    name: "",
    gender: "",
    fatherSpouseName: "",
    dateOfBirth: "",
    highestQualification: "",
    bloodGroup: "",
    mobileNo: "",
    panNo: "",
    aadharNo: "",
    uanNo: "",
    nominationName: "",
    nominationRelation: "",
    nominationDOB: "",

    // Office use section
    designation: "",
    grade: "",
    department: "",
    location: "",
    salesOffice: "",
    dateOfJoining: "",
    reportingManager: "",

    // Header section
    offerLetterDate: "",
    reportingDate: "",

    // Declaration
    declarationAccepted: false,
  });

  // check user exist or not
  useEffect(() => {
    if (!user) {
      logout();
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = async (e, type) => {
    e.preventDefault();
    setIsModalOpen(true);
    // Basic validation
    try {
      if (!formData.declarationAccepted) {
        alert("Please accept the declaration and sign by checking the checkbox.");
        return;
      }

      if (
        !formData.name ||
        !formData.gender ||
        !formData.dateOfBirth ||
        !formData.mobileNo
        || !formData.offerLetterDate
        || !formData.reportingDate
        || !formData.fatherSpouseName
        || !formData.bloodGroup
        || !formData.panNo
        || !formData.aadharNo
        || !formData.uanNo
        || !formData.nominationName
        || !formData.nominationRelation
        || !formData.nominationDOB
      ) {
        alert("Please fill in all required fields marked with *");
        return;
      }
      const finalData = {
        eid: !eid ? user.eid : eid,
        applicationId: `KCL${new Date().getFullYear()}${String(
          Math.floor(Math.random() * 10000)
        ).padStart(4, "0")}`,
        formType: "Joining",
        submissionDate: new Date().toISOString(),
        data: formData,
        submitType: type,
      };
      await fetch(
        `${process.env.REACT_APP_PUBLIC_API_BASE_URL}/v1/employees/save-application`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify(finalData),
        }
      );
      navigate("/");
      checkAuthStatus();
    } catch (error) {
      console.error(error);
    }
  };

  const handleReset = () => {
    setFormData({
      name: "",
      gender: "",
      fatherSpouseName: "",
      dateOfBirth: "",
      highestQualification: "",
      bloodGroup: "",
      mobileNo: "",
      panNo: "",
      aadharNo: "",
      uanNo: "",
      nominationName: "",
      nominationRelation: "",
      nominationDOB: "",
      designation: "",
      grade: "",
      department: "",
      location: "",
      salesOffice: "",
      dateOfJoining: "",
      reportingManager: "",
      offerLetterDate: "",
      reportingDate: "",
      declarationAccepted: false,
    });
  };


  const getEmployeeData = async (eid, formType) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_PUBLIC_API_BASE_URL}/v1/employees/get-application?eid=${eid}&formType=${formType}`,
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
          }
        }
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  function extractEmployeeCore(finalData) {
    if (!finalData) return null;
    console.log(finalData);
    let data = finalData.data;
    if (!data) return null;

    return {
      name:
        `${data.formData?.firstName ?? ""}${
          data.formData?.middleName
            ? " " + data.formData?.middleName
            : ""
        } ${data.formData?.surname ?? ""}` || "", // or full_name if you prefer
      bloodGroup: data.formData?.bloodGroup || "",
      dateOfBirth: data.formData?.dobISO || "",
      panNo: data.formData?.panNo || "",
      aadharNo: data.formData?.aadhaarNo || "",
      mobileNo: data.formData?.presentPhone || "",
      gender: data.formData?.gender || ""
      
    };
  }
  const [isSubmitted, setIsSubmitted] = useState(false);

  const fetchEmployeeData = async () => {
    try {
      // First try Joining API
      const joiningData = await getEmployeeData(user.eid, "Joining");
  
      if (joiningData?.data) {
        setFormData(joiningData.data);
        setIsSubmitted(joiningData.approved);
      } else {
        // If Joining data is empty, try Personal API
        const personalData = await getEmployeeData(user.eid, "Personal");
        setFormData(prev => ({
          ...prev,
          ...extractEmployeeCore(personalData),
        }));
      }
  
    } catch (error) {
      // If Joining API failed (e.g. 404), fallback to Personal
      try {
        const personalData = await getEmployeeData(user.eid, "Personal");
        setFormData(prev => ({
          ...prev,
          ...extractEmployeeCore(personalData),
        }));
      } catch (err2) {
        console.error("Both API calls failed:", err2);
      }
    }
  };
  
  useEffect(() => {
    if (!user) return;
    if(data){
      setFormData(data);
      return;
    }
    fetchEmployeeData();
  }, []);

  return (
    <>
      {/* <ConfirmationModal 
    isOpen={isModalOpen}
    onClose={() => setIsModalOpen(false)}
    title="Confirmation"
    message="Are you sure you want to submit this form?"
    onConfirm={handleSubmit}
    onCancel={handleReset}
    confirmText="Submit"
    cancelText="Cancel"
/> */}
      <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8" ref={printRef}>
        <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
          {/* Header */}
          <div className="bg-black text-white p-6">
            <div className="flex flex-col sm:flex-row items-center justify-between">
              <div className="flex items-center space-x-4">
                {/* Logo placeholder */}
                <img
                  src="/images/kajaria-logo.png"
                  alt="Kajaria Logo"
                  style={{ width: "100%", height: "50px" }}
                />
                <div className="flex flex-col items-center w-full">
                  <h1 className="text-2xl font-bold">JOINING REPORT</h1>
                  <p className="text-blue-100">HEAD OFFICE</p>
                </div>
              </div>
              <div className="mt-4 sm:mt-0 text-right">
                <p className="text-blue-100">
                  Dated: {new Date().toLocaleDateString()}
                </p>
              </div>
            </div>
          </div>

          <div className="p-6 space-y-8">
            {/* Reference Section */}
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="text-gray-700 mb-4">Sir/Madam,</p>
              <p className="text-gray-700 mb-4">
                With reference to your Offer Letter dated _____________, I
                hereby report for duty on _____________
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Offer Letter Date <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="date"
                    disabled={isSubmitted}
                    name="offerLetterDate"
                    value={formData.offerLetterDate}
                    onChange={handleInputChange}
                    className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Reporting Date <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="date"
                    disabled={isSubmitted}
                    name="reportingDate"
                    value={formData.reportingDate}
                    onChange={handleInputChange}
                    className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
              </div>
            </div>

            {/* Employee Details Section */}
            <div>
              <h2 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-blue-600 pb-2">
                PARTICULARS OF NEW JOINEE
              </h2>
              <p className="text-sm text-gray-600 mb-6 italic">
                (Filled By Employee)
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    disabled={isSubmitted}
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Gender <span className="text-red-500">*</span>
                  </label>
                  <select
                    name="gender"
                    value={formData.gender}
                    onChange={handleInputChange}
                    className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Father's/Spouse Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    disabled={isSubmitted}
                    name="fatherSpouseName"
                    value={formData.fatherSpouseName}
                    onChange={handleInputChange}
                    className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Date of Birth <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="date"
                    disabled={isSubmitted}
                    name="dateOfBirth"
                    value={formData.dateOfBirth}
                    onChange={handleInputChange}
                    className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Highest Qualification <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    disabled={isSubmitted}
                    name="highestQualification"
                    value={formData.highestQualification}
                    onChange={handleInputChange}
                    className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Blood Group <span className="text-red-500">*</span>
                  </label>
                  <select
                    disabled={isSubmitted}
                    name="bloodGroup"
                    value={formData.bloodGroup}
                    onChange={handleInputChange}
                    className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  >
                    <option value="">Select Blood Group</option>
                    <option value="A+">A+</option>
                    <option value="A-">A-</option>
                    <option value="B+">B+</option>
                    <option value="B-">B-</option>
                    <option value="AB+">AB+</option>
                    <option value="AB-">AB-</option>
                    <option value="O+">O+</option>
                    <option value="O-">O-</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Mobile No <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="tel"
                    disabled={isSubmitted}
                    name="mobileNo"
                    value={formData.mobileNo}
                    onChange={handleInputChange}
                    className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    PAN <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="panNo"
                    disabled={isSubmitted}
                    value={formData.panNo}
                    onChange={handleInputChange}
                    placeholder="ABCDE1234F"
                    className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                <div className="pdf-break">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Aadhar <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="aadharNo"
                    disabled={isSubmitted}
                    value={formData.aadharNo}
                    onChange={handleInputChange}
                    placeholder="1234 5678 9012"
                    className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    UAN <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="uanNo"
                    disabled={isSubmitted}
                    value={formData.uanNo}
                    onChange={handleInputChange}
                    className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                {/* nomination name & relation required */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Name of the Nominee (Term Insurance/Personal Accident) <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="nominationName"
                    disabled={isSubmitted}
                    value={formData.nominationName}
                    onChange={handleInputChange}
                    className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Nominee DOB <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="date"
                    disabled={isSubmitted}
                    name="nominationDOB"
                    value={formData.nominationDOB}
                    onChange={handleInputChange}
                    className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Nominee Relationship <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    disabled={isSubmitted}
                    name="nominationRelation"
                    value={formData.nominationRelation}
                    onChange={handleInputChange}
                    className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
              </div>
            </div>

            {/* Office Use Section */}
            <div className="bg-yellow-50 p-6 rounded-lg">
              <h3 className="text-lg font-bold text-gray-800 mb-4">
                (For Office Use Only)
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Designation
                  </label>
                  <input
                    type="text"
                    disabled={isSubmitted}
                    name="designation"
                    value={formData.designation}
                    onChange={handleInputChange}
                    className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Grade
                  </label>
                  <input
                    type="text"
                    disabled={isSubmitted}
                    name="grade"
                    value={formData.grade}
                    onChange={handleInputChange}
                    className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Department
                  </label>
                  <input
                    type="text"
                    disabled={isSubmitted}
                    name="department"
                    value={formData.department}
                    onChange={handleInputChange}
                    className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Location
                  </label>
                  <input
                    type="text"
                    disabled={isSubmitted}
                    name="location"
                    value={formData.location}
                    onChange={handleInputChange}
                    className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Sales Office (if applicable)
                  </label>
                  <input
                    type="text"
                    name="salesOffice"
                    disabled={isSubmitted}
                    value={formData.salesOffice}
                    onChange={handleInputChange}
                    className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Date of Joining
                  </label>
                  <input
                    type="date"
                    name="dateOfJoining"
                    disabled={isSubmitted}
                    value={formData.dateOfJoining}
                    onChange={handleInputChange}
                    className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Reporting Manager (RM)
                  </label>
                  <input
                    type="text"
                    disabled={isSubmitted}
                    name="reportingManager"
                    value={formData.reportingManager}
                    onChange={handleInputChange}
                    className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
              </div>
            </div>

            {/* Declaration & Digital Signature Section */}
            <div className="pdf-break border-t pt-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">
                Declaration & Digital Signature
              </h3>
              <div className="bg-blue-50 p-6 border-l-4 border-blue-500 rounded-r-lg">
                <p className="text-gray-700 leading-relaxed mb-6">
                  I hereby declare that the information provided above is true
                  and correct to the best of my knowledge. I understand that any
                  false information may lead to the rejection of my application
                  or termination of employment. I agree to abide by the
                  company's rules, regulations, and policies.
                </p>

                <div className="flex items-start space-x-3">
                  <input
                    type="checkbox"
                    disabled={isSubmitted}
                    name="declarationAccepted"
                    checked={formData.declarationAccepted}
                    onChange={handleInputChange}
                    className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500 mt-1"
                  />
                  <label className="text-sm text-gray-700 font-medium">
                    I accept the above declaration and digitally sign this
                    document by checking this box.
                    <span className="text-red-500"> *</span>
                  </label>
                </div>

                {/* {formData.declarationAccepted && (
                  <div className="mt-4 p-3 bg-green-50 border border-green-200 rounded-md">
                    <p className="text-green-700 text-sm font-medium">
                      ✓ Document signed digitally on{" "}
                      {new Date().toLocaleDateString()} at{" "}
                      {new Date().toLocaleTimeString()}
                    </p>
                  </div>
                )} */}
              </div>
            </div>

            {/* Buttons */}
            <div className="no-print flex flex-col sm:flex-row gap-4 pt-6">
              <button
                type="button"
                onClick={()=>handlePrintToPDF(printRef, formData.name)}
                className="flex-1 bg-gray-500 text-white py-3 px-6 rounded-md hover:bg-gray-600 transition duration-200 font-medium"
              >
                Print
              </button>
              <button
                type="button"
                onClick={(e)=>handleSubmit(e, "Final")}
                disabled={isSubmitted}
                className="flex-1 bg-blue-600 text-white py-3 px-6 rounded-md hover:bg-blue-700 transition duration-200 font-medium"
              >
                Submit Form
              </button>
              {/* <button
                type="button"
                onClick={handleReset}
                className="flex-1 bg-gray-500 text-white py-3 px-6 rounded-md hover:bg-gray-600 transition duration-200 font-medium"
              >
                Reset Form
              </button> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JoiningReportForm;
